// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field {
  display: flex;
  flex-direction: column;
}

form {
  margin-bottom: 2rem;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  margin-bottom: 2rem;
}

.groups-field {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.groups-field .group-field {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, auto));
  gap: 1rem;
}
.groups-field button {
  margin-top: 1rem;
  width: -moz-fit-content;
  width: fit-content;
}

.translations {
  margin: 2rem 0;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV0bC1kaWN0aW9ubmFyeS1lZGl0LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBQTtFQUNBLHNCQUFBO0FBQ0o7O0FBRUE7RUFDSSxtQkFBQTtBQUNKOztBQUVBO0VBQ0ksYUFBQTtFQUNBLDhCQUFBO0VBQ0Esb0JBQUE7RUFDQSxTQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFFQTtFQUNJLGFBQUE7RUFDQSxzQkFBQTtFQUNBLFNBQUE7QUFDSjtBQUNJO0VBQ0ksYUFBQTtFQUNBLDZEQUFBO0VBQ0EsU0FBQTtBQUNSO0FBRUk7RUFDSSxnQkFBQTtFQUNBLHVCQUFBO0VBQUEsa0JBQUE7QUFBUjs7QUFJQTtFQUNJLGNBQUE7QUFESiIsImZpbGUiOiJldGwtZGljdGlvbm5hcnktZWRpdC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5maWVsZCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuXG5mb3JtIHtcbiAgICBtYXJnaW4tYm90dG9tOiAycmVtO1xufVxuXG4uYWN0aW9ucyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IHN0cmV0Y2g7XG4gICAgZ2FwOiAxcmVtO1xuICAgIG1hcmdpbi1ib3R0b206IDJyZW07XG59XG5cbi5ncm91cHMtZmllbGQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBnYXA6IDFyZW07XG5cbiAgICAuZ3JvdXAtZmllbGQge1xuICAgICAgICBkaXNwbGF5OiBncmlkO1xuICAgICAgICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdChhdXRvLWZpbGwsIG1pbm1heCgxOHJlbSwgYXV0bykpO1xuICAgICAgICBnYXA6IDFyZW07XG4gICAgfVxuICAgIFxuICAgIGJ1dHRvbiB7XG4gICAgICAgIG1hcmdpbi10b3A6IDFyZW07XG4gICAgICAgIHdpZHRoOiBmaXQtY29udGVudDtcbiAgICB9XG59XG5cbi50cmFuc2xhdGlvbnMge1xuICAgIG1hcmdpbjogMnJlbSAwO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl-dictionnary/etl-dictionnary-edit/etl-dictionnary-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,6DAAA;EACA,SAAA;AACR;AAEI;EACI,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAAR;;AAIA;EACI,cAAA;AADJ;AAEA,o4CAAo4C","sourcesContent":[".field {\n    display: flex;\n    flex-direction: column;\n}\n\nform {\n    margin-bottom: 2rem;\n}\n\n.actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.groups-field {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n\n    .group-field {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(18rem, auto));\n        gap: 1rem;\n    }\n    \n    button {\n        margin-top: 1rem;\n        width: fit-content;\n    }\n}\n\n.translations {\n    margin: 2rem 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
